import React from 'react';
import './quienes-somos.scss';
import bg from '../../assets/img/bg-quienes-somos.png';
const QuienesSomosPage = () => {
return(
  <section>
      <div className="container-fluid">
          <div className="row p-0">
              <div className="col-lg-12 p-0">
                  <img src={bg} alt="..." style={{width:"100px"}} className="img-nuestra-historia"/>
              </div>
          </div>
      </div> 
      <div className="container">
          <div className="row mt-5">
              <div className="col-lg-12">
                  <h2 className="global_title bold">
                      Nuestra Historia
                  </h2>
                  <hr className="hr6" />
                  <div className="contenido">
                  <p><strong>What is Lorem Ipsum?</strong> <br/> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
                  <p><strong>Why do we use it?</strong> <br/>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes.</p>
                  </div>
              </div>
          </div>
      </div>
  </section>
);
}
export default QuienesSomosPage;